import { Route } from '@angular/router';
import { HomeComponent } from './feature/home/home.component';
import { TermAndConditionComponent } from './feature/term-and-condition/term-and-condition.component';
import { PrivacyPolicyComponent } from './feature/privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './feature/cookies-policy/cookies-policy.component';
import { Lib404PageNotFoundComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';

export enum ROUTER_TOKENS {
  NANKANG = 'NANKANG',
  // HOME = 'home',
  PRODUCTS = 'products',
  PROMOTIONS = 'promotions',
  VIDEOS = 'videos',
  NEWS = 'news',
  ARTICLE = 'article',
  BRANCHES = 'branches',
  ABOUT_US = 'about-us',
  FRANCHISE = 'franchise',
  AFTER_SALE_SERVICE = 'after-sale-service',
  WARRANTY_POLICY = 'warrantyPolicy',
  CONTACT_US = 'contact-us',
  TERM_AND_CONDITION = 'term-and-condition',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIES_POLICY = 'cookies-policy',
  TIRE = 'tire',
  LUBRICANT = 'lubricant',
  BREAK = 'brake',
}

export const appRoutes: Route[] = [
  // {
  //   path: '',
  //   redirectTo: ROUTER_TOKENS.HOME,
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: HomeComponent,
    data: {
      name: ROUTER_TOKENS.NANKANG,
      title: 'NANKANG Tire Thailand | ยางคุ้มค่า ทนทาน เกาะถนน',
      description:
        'เว็บไซต์ทางการของ NANKANG Tire Thailand ครบทั้งซื้อยาง และข้อมูลสเปก/ไซซ์สำหรับเก๋ง กระบะ SUV และ 4x4 โดดเด่นเรื่องความคุ้มค่าและความทนทาน เกาะถนนมั่นใจทั้งถนนเปียก/แห้ง ค้นหารุ่นที่ใช่ เช็กราคา เลือกสาขาและโทรจองคิวได้ทันทีทั่วไทย | NANKANG Tire Thailand',
      keywords:
        'ยาง nankang, ยาง nankang ราคา, NANKANG Tire Thailand, ยางราคาคุ้มค่า nankang, เปลี่ยนยางรถยนต์ nankang, ราคายางรถยนต์ nankang',
      robots: 'index, follow',
      canonical: 'https://nankangtire.in.th',
      publisher: 'NANKANG',
    },
  },
  {
    path: ROUTER_TOKENS.TERM_AND_CONDITION,
    component: TermAndConditionComponent,
    data: {
      name: ROUTER_TOKENS.NANKANG,
      title: 'ข้อกำหนดและเงื่อนไขการใช้บริการ | NANKANG Tire Thailand',
      description:
        'เอกสารข้อกำหนดและเงื่อนไขการใช้เว็บไซต์/บริการของ NANKANG ครอบคลุมขอบเขตการใช้งาน สิทธิและหน้าที่ของผู้ใช้ หลักเกณฑ์ทางกฎหมาย ข้อจำกัดความรับผิด และแนวทางการติดต่อ เพื่อความโปร่งใสและความมั่นใจในการใช้งานทุกส่วนของเว็บไซต์ | NANKANG Tire Thailand',
      keywords: '',
      robots: 'index, follow',
      canonical: 'https://nankangtire.in.th/term-and-condition',
      publisher: 'NANKANG',
    },
  },
  {
    path: ROUTER_TOKENS.PRIVACY_POLICY,
    component: PrivacyPolicyComponent,
    data: {
      name: ROUTER_TOKENS.NANKANG,
      title: 'นโยบายความเป็นส่วนตัว | NANKANG Tire Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย ให้คุณใช้งานเว็บไซต์และบริการของ NANKANG ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | NANKANG Tire Thailand',
    },
  },
  {
    path: ROUTER_TOKENS.COOKIES_POLICY,
    component: CookiesPolicyComponent,
    data: {
      name: ROUTER_TOKENS.NANKANG,
      title: 'นโยบายคุกกี้ | การใช้และการจัดการคุกกี้ | NANKANG Tire Thailand',
      description:
        'ชี้แจงประเภทคุกกี้ วัตถุประสงค์ด้านฟังก์ชัน การวิเคราะห์ และการโฆษณา อธิบายผลต่อประสบการณ์ผู้ใช้ พร้อมวิธีตั้งค่า/จัดการความยินยอมในเบราว์เซอร์ คุณสามารถปรับเปลี่ยนการยินยอมได้ทุกเมื่อ เพื่อให้การใช้งานเว็บไซต์เหมาะกับความต้องการมากที่สุด | NANKANG Tire Thailand',
    },
  },
  {
    path: ROUTER_TOKENS.PRODUCTS,
    loadChildren: () => import('./feature/products/products.routes').then((m) => m.productRoutes),
  },
  {
    path: ROUTER_TOKENS.PROMOTIONS,
    loadChildren: () => import('./feature/promotions/promotions.routes').then((m) => m.promotionsRoutes),
  },
  {
    path: ROUTER_TOKENS.VIDEOS,
    loadChildren: () => import('./feature/videos/videos.routes').then((m) => m.videosRoutes),
  },
  {
    path: ROUTER_TOKENS.NEWS,
    loadChildren: () => import('./feature/news/news.routes').then((m) => m.newsRoutes),
  },
  {
    path: ROUTER_TOKENS.ARTICLE,
    loadChildren: () => import('./feature/article/article.routes').then((m) => m.articleRoutes),
  },
  {
    path: ROUTER_TOKENS.BRANCHES,
    loadChildren: () => import('./feature/branches/branches.routes').then((m) => m.branchesRoutes),
  },
  {
    path: ROUTER_TOKENS.ABOUT_US,
    loadChildren: () => import('./feature/about-us/about-us.routes').then((m) => m.aboutUsRoutes),
  },
  {
    path: '**',
    component: Lib404PageNotFoundComponent,
  },
];
